<template>
  <div class="com">
    <el-drawer :title="title" :size="width" :visible.sync="drawer_" :direction="direction">
      <div class="demo-drawer__content">
        <slot></slot>
        <div class="demo-drawer__footer">
          <el-button @click="cancelModal()">取 消</el-button>
          <el-button type="primary" @click="confirmModal()"
            >确定
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  props: {
    footer: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "600px"
    },
    direction: {
      type: String,
      default: "rtl"
    }
  },
  data() {
    return {};
  },
  methods:{
      cancelModal(){
        this.$store.dispatch('CancelLoading')
          this.$emit("onCancel")
      },
      confirmModal(){
          this.$emit("onOk")
      }

  },
  computed: {
    drawer_: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("toggleShow", v);
      }
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/lib/modal.vue